// A form-level `resetOptions` is merged into every `reset`, so dropping dirty state needs an opt-out
export const KEEP_DIRTY_VALUES = { keepDirtyValues: true };

export const CLEAR_DIRTY_VALUES = { keepDirtyValues: false };
